import { useState } from 'react'
import { useSession } from '@wiggot/auth/hooks/useSession'
import { deleteCookiesAuth } from '@wiggot/auth/utils/cookies'
import { toast } from '@dd3tech/wiggui/Toast'
import { patchUpdateProfile } from '../../../../../services'
import { postLogOut, postLogOutV2 } from '../../../../../services/auth.services'
import { useModalTermsConditionsStore } from '../../../../../store'
import { updateCookieProfile } from '../../../../../utils'
import {
  ROUTES,
  NEXT_PUBLIC_TERMS_AND_CONDITIONS_LAST_VERSION
} from '../../../../../constants'

export const useModalTermsAndConditions = () => {
  const isOpen = useModalTermsConditionsStore((state) => state.isOpen)
  const setIsOpen = useModalTermsConditionsStore((state) => state.setIsOpen)
  const { updateProfile, profile } = useSession()

  const [isLoading, setIsLoading] = useState(false)
  const [isLoadingReject, setIsLoadingReject] = useState(false)

  const handleReject = async () => {
    setIsLoadingReject(true)
    const { isSuccess } = await postLogOut()
    const { isSuccess:isSuccessV2 } = await postLogOutV2()
    if (isSuccess || isSuccessV2) {
      deleteCookiesAuth()
      window.location.href = ROUTES.AUTH_LOGIN
    } else {
      toast({
        title: 'Ocurrió un error al cerrar sesión',
        type: 'error'
      })
    }
    setIsLoadingReject(false)
  }

  const handleAccept = async () => {
    setIsLoading(true)
    try {
      const { isSuccess } = await patchUpdateProfile({
        terms_and_conditions: NEXT_PUBLIC_TERMS_AND_CONDITIONS_LAST_VERSION
      })

      if (isSuccess) {
        if (profile) {
          const newProfileUser = {
            ...profile,
            termsAndConditions: NEXT_PUBLIC_TERMS_AND_CONDITIONS_LAST_VERSION
          }

          const newProfile = updateCookieProfile(profile, newProfileUser)
          updateProfile(newProfile)
        }

        setIsOpen(false)
      } else {
        toast({
          type: 'error',
          title: 'Ocurrio un error inesperado',
          description: 'Por favor intenta nuevamente'
        })
      }
    } catch {
      toast({
        type: 'error',
        title: 'Ocurrio un error inesperado',
        description: 'Por favor intenta nuevamente'
      })
    } finally {
      setIsLoading(false)
    }
  }
  return {
    isOpen,
    setIsOpen,
    handleReject,
    handleAccept,
    isLoading,
    isLoadingReject
  }
}
